import { render, staticRenderFns } from "./ReceivedMails.vue?vue&type=template&id=45580a54&scoped=true&"
import script from "./ReceivedMails.vue?vue&type=script&lang=js&"
export * from "./ReceivedMails.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedMails.vue?vue&type=style&index=0&id=45580a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45580a54",
  null
  
)

export default component.exports